import { AmountFormControl, GlobalControl } from '@hb/domain';
import { QuestionKey } from '@hb/modules/global/global.constants';
import { StoreOptionInterface } from '@hb/modules/global/store-interface/store-option-interface';

import { inject, InjectionToken } from '@angular/core';

export const GLOBAL_STORE = new InjectionToken('GLOBAL_STORE');
export const QUESTION_KEY = new InjectionToken<QuestionKey>('QUESTION_KEY');
export const CO_QUESTION_KEY = new InjectionToken<QuestionKey | undefined>('CO_QUESTION_KEY');

export class GlobalInjectComponent<T extends StoreOptionInterface<any>> {
    protected readonly store = inject(GLOBAL_STORE) as T;
    protected readonly questionKey: QuestionKey = inject(QUESTION_KEY);
    protected readonly coQuestionKey?: QuestionKey = inject(CO_QUESTION_KEY, { optional: true }) ?? undefined;

    mainApplicantControl: AmountFormControl<any> | GlobalControl<any>;
    coApplicantControl?: AmountFormControl<any> | GlobalControl<any>;

    hasCoApplicant = false;

    constructor() {
        this.store.getHasCoApplicant().subscribe((hasCoApplicant) => {
            this.hasCoApplicant = hasCoApplicant;
        });
    }

    nextQuestion(): void {
        if (this.isValidController()) {
            this.store.nextQuestion();
        } else {
            this.controllerVerify();
        }
    }

    private isValidController(): boolean {
        return this.coQuestionKey && this.hasCoApplicant
            ? this.mainApplicantControl.valid && this.coApplicantControl.valid
            : this.mainApplicantControl.valid;
    }

    private controllerVerify(): void {
        this.mainApplicantControl.markAsDirty();
        this.mainApplicantControl.markAsTouched();
        this.mainApplicantControl.updateValueAndValidity();

        if (this.coQuestionKey) {
            this.coApplicantControl.markAsDirty();
            this.coApplicantControl.markAsTouched();
            this.coApplicantControl.updateValueAndValidity();
        }
    }
}
